import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class TemplateSelection extends Component {
  state = {
    tabCount: 0,
  };

  componentDidMount() {
    // To focus the first template after the templates load.
    if (this.props.templates.length > 0 && !this.props.loading) {
      this[`myRef_${this.state.tabCount}`].current.focus();
    }
  }

  componentDidUpdate() {
    // To focus the first template after things are updated.
    if (this.props.templates.length > 0 && !this.props.loading) {
      this[`myRef_${this.state.tabCount}`].current.focus();
    }
  }

  handleKey = e => {
    const { templates, cloneTemplate } = this.props;
    const { tabCount } = this.state;
    // handles the focusing when pressed all the arrow keys and enter.
    if (e.which === 13) {
      cloneTemplate(templates[tabCount]);
    } else if (e.keyCode === 39 && Number(tabCount) < templates.length - 1) {
      this[`myRef_${Number(tabCount) + 1}`].current.focus();
    } else if (e.which === 37 && Number(tabCount) > 0) {
      this[`myRef_${Number(tabCount) - 1}`].current.focus();
    } else if (e.which === 40 && Number(tabCount) + 4 < templates.length) {
      this[`myRef_${Number(tabCount) + 4}`].current.focus();
    } else if (e.which === 38 && Number(tabCount) - 4 > -1) {
      this[`myRef_${Number(tabCount) - 4}`].current.focus();
    }
  };

  targetFocus = e => {
    // sets the state with the title of the focused div.
    this.setState({
      tabCount: e.target.title,
    });
  };

  _displayTemplates = () => {
    const { loading, pbListLength, templates } = this.props;

    // Making refs for all the template divs.
    if (!loading) {
      this.props.templates.forEach((elem, index) => {
        this[`myRef_${index}`] = React.createRef();
      });
    }

    // Show loading message
    if (loading) {
      return (
        <div className="quote-create-template-selection">
          <span className="loader-label"> Loading templates . . . . </span>
        </div>
      );
    }
    if (pbListLength === 0) {
      return (
        <div className="from-template">
          <div className="no-template-label">
            No Pricebooks are available. Can&rsquo;t create document.
            <span role="img" aria-label="Sad">
              😕
            </span>
          </div>
        </div>
      );
    }

    return (
      <div
        className="quote-create-template-selection"
        data-test="templateselection-quote-create-template-selection">
        {Array.isArray(templates) &&
          templates.map((template, index) => (
            <div
              key={template.id}
              className="quote-create-template"
              data-test="templateselection-quote-create-template"
              onKeyDown={e => this.handleKey(e, template, index)}
              id={template.title.replace(/ +/g, "-").toLowerCase()}
              onClick={() => this.props.cloneTemplate(template)}
              onKeyPress={() => {}}
              title={index}
              tabIndex="0"
              ref={this[`myRef_${index}`]}
              onFocus={this.targetFocus}
              role="button">
              <div
                className="quote-create-templatecard"
                data-test="templateselection-quote-create-templatecard">
                <img
                  data-test="templateselection-template-image"
                  src={`${template.thumbnail}`}
                  alt={`${template.title}`}
                />
              </div>
              <div
                className="quote-create-templatecardname"
                data-test="templateselection-quote-create-templatecardname">
                {template.title}
              </div>
            </div>
          ))}
        <div
          data-test="tempalteselection-create-new-template"
          className="templatecreatetemp-custom-temp-ico"
          onClick={this.props.setView}
          onKeyPress={() => {}}
          title="make-template"
          role="button"
          tabIndex="0">
          <i>
            <FontAwesomeIcon icon={["far", "plus"]} />
          </i>
          <span>Make your own template</span>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div
        className="quote-create-template-selection-wrapper"
        data-test="templateselection-template-selection-wrapper">
        {this._displayTemplates()}
      </div>
    );
  }
}

export default TemplateSelection;



// WEBPACK FOOTER //
// ./src/components/CreateTemplatePopup/TemplateSelection.js